module.exports = __webpack_public_path__ + "static/media/be.63abac7d.png";